import { SaleFormValues } from './types';

export const validateSaleForm = {
  crop_id: (value?: string) => !value ? 'Crop is required' : '',
  
  vendor_id: (value?: string) => !value ? 'Vendor is required' : '',
  
  quantity: (value?: string) => {
    if (!value) return 'Quantity is required';
    const num = Number(value);
    if (isNaN(num)) return 'Quantity must be a number';
    if (num <= 0) return 'Quantity must be greater than 0';
    return '';
  },
  
  unit_price: (value?: string) => {
    if (!value) return 'Unit price is required';
    const num = Number(value);
    if (isNaN(num)) return 'Unit price must be a number';
    if (num <= 0) return 'Unit price must be greater than 0';
    return '';
  },
  
  purchase_price: (value?: string) => {
    if (!value) return '';
    const num = Number(value);
    if (isNaN(num)) return 'Purchase price must be a number';
    if (num < 0) return 'Purchase price cannot be negative';
    return '';
  },
  
  sale_date: (value?: string) => {
    if (!value) return 'Sale date is required';
    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid date format';
    if (date > new Date()) return 'Sale date cannot be in the future';
    return '';
  }
};